// apps/dashboard/src/stores/auth.store.ts
// JWT auth state — persisted to localStorage.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const TOKEN_KEY = 'omniflow:token';

export interface AuthUser {
  id: string;
  tenantId: string;
  tenantSlug: string;
  tenantName: string;
  email: string;
  role: 'OWNER' | 'ADMIN' | 'AGENT' | 'SUPERVISOR';
  isReseller?: boolean;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: AuthUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      setAuth: (token, user) => {
        localStorage.setItem(TOKEN_KEY, token);
        set({ token, user, isAuthenticated: true });
      },
      logout: () => {
        localStorage.removeItem(TOKEN_KEY);
        set({ token: null, user: null, isAuthenticated: false });
      },
    }),
    {
      name: 'omniflow:auth',
      partialize: (s) => ({ token: s.token, user: s.user, isAuthenticated: s.isAuthenticated }),
    },
  ),
);
